import { Box, Button, FormHelperText, TextField } from "@mui/material";
import { Field, FieldProps, useFormikContext } from "formik";
import * as React from "react";

interface FormikCodeFieldProps {
  name: string;
  codeLength: number;
}

export const FormikCodeField: React.FC<FormikCodeFieldProps> = (props) => {
  const formik = useFormikContext();
  const itemsRef = React.useRef<HTMLInputElement[]>([]);

  return (
    <Field name={props.name}>
      {({ field, meta }: FieldProps<string[]>) => (
        <>
          <Box
            sx={{
              columnGap: "16px",
              display: "grid",
              gridTemplateColumns: "repeat(7, 1fr)",
              py: 1,
            }}
          >
            {[...Array(props.codeLength).keys()].map((ref, i) => (
              <TextField
                error={Boolean(
                  Array.isArray(meta.touched) &&
                    meta.touched.length === props.codeLength &&
                    meta.error
                )}
                fullWidth
                inputRef={(el: HTMLInputElement) => {
                  itemsRef.current[i] = el;
                }}
                key={`code-${i}`}
                name={`code[${i}]`}
                onBlur={(e) => field.onBlur(e)}
                onKeyDown={(event) => {
                  if (event.code === "ENTER") {
                    if (field.value[i]) {
                      formik.setFieldValue(`code[${i}]`, "");
                      return;
                    }

                    if (i > 0) {
                      formik.setFieldValue(`code[${i}]`, "");
                      itemsRef.current[i - 1].focus();
                      return;
                    }
                  }

                  if (Number.isInteger(parseInt(event.key, 10))) {
                    formik.setFieldValue(`code[${i}]`, event.key);

                    if (i < 5) {
                      itemsRef.current[i + 1].focus();
                    }
                  }
                }}
                onPaste={(event) => {
                  const paste = event.clipboardData.getData("text");
                  const pasteArray = paste.split("");

                  if (pasteArray.length !== props.codeLength) {
                    return;
                  }

                  const valid = pasteArray.every((x) =>
                    Number.isInteger(parseInt(x, 10))
                  );

                  if (valid) {
                    formik.setFieldValue(props.name, pasteArray);
                    itemsRef.current[5].focus();
                  }
                }}
                value={field.value[i]}
                sx={{
                  display: "inline-block",
                  textAlign: "center",
                  "& .MuiInputBase-input": {
                    textAlign: "center",
                  },
                }}
                variant="outlined"
              />
            ))}
            <Button
              variant="outlined"
              onClick={() => {
                formik.setFieldValue(props.name, ["", "", "", "", "", ""]);
              }}
            >
              Reset
            </Button>
          </Box>
          <Box sx={{}}>
            {Boolean(meta.touched && meta.error) && (
              <FormHelperText error sx={{ mx: "14px" }}>
                MFA Code is a required field
              </FormHelperText>
            )}
          </Box>
        </>
      )}
    </Field>
  );
};
